export const PERMS = {
    READ: 'transport_scoring.read',
    UPDATE: 'transport_scoring.update',
    DELETE: 'transport_scoring.delete',
    CREATE: 'transport_scoring.create',
}
